/**
 * Created by tomers on 10/13/2014.
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Translator = require("i18n/translator");

    var PLUGINS = {
        "Link":"link",
        "Smiley":"smiley"
    };

    function dialogDefinition(ev) {
        var definition = ev.data.definition;
        var pluginName = ev.data.name;
        var onShowOriginal = definition.onShow;
        var onPluginDialogShow = null;

        definition.resizable = false;
        definition.draggable = false;

        // in order to show the "OK" to the right (if there are only two buttons)
        /*jshint validthis:true */
        if (definition.buttons.length > 1) {
            var firstButton = definition.buttons[0](this.currentInstance);
            if (firstButton.id === "ok") {
                definition.buttons.reverse();
            }
        }

        if (pluginName === PLUGINS.Link) {

            definition.minWidth = 330;
            definition.minHeight = 70;

            var infoTab = definition.getContents("info");

            infoTab.get("urlOptions").children[0].widths = ["0%","100%"];

            var urlField = infoTab.get("url");
            urlField.onKeyUp = function() {
                // just do nothing! override the onKeyUp that filter out the protocol from the URL
            };
            urlField.validate = null;

            infoTab.add({
                type: "text",
                label: "Name",
                id: "name"
            }, "urlOptions");


            onPluginDialogShow = function(ev) {
                if (definition.dialog.getValueOf("target", "linkTargetType") === "notSet") {
                    definition.dialog.setValueOf("target", "linkTargetType", "_blank");
                }
                definition.dialog.hidePage("target");

                var linkType = definition.dialog.getContentElement("info","linkType");
                linkType.getElement().getParent().hide();

                var urlValue = definition.dialog.getValueOf("info", "url");
                var protocolValue = definition.dialog.getValueOf("info", "protocol");
                definition.dialog.setValueOf("info", "protocol", "");
                if (urlValue !== "") {
                    definition.dialog.setValueOf("info", "url", protocolValue + urlValue);
                }

                var protocol = definition.dialog.getContentElement("info","protocol");
                protocol.getElement().getParent().hide();

                var url = definition.dialog.getContentElement("info", "url");
                url.getInputElement().removeClass("error");
                url.getInputElement().$.placeholder = "http://";

                var name = definition.dialog.getContentElement("info", "name");
                name.getInputElement().$.placeholder = Translator.translate("LEUIComponents.ckeditor.plugins.link.name");
                var selectedText = definition.dialog.getParentEditor().getSelection().getSelectedText();
                definition.dialog.setValueOf("info", "name", selectedText);

            };

            definition.onOk = function (ev){
                var plugin = CKEDITOR.plugins.link;
                var editor = definition.dialog.getParentEditor();
                var data = {};

                var url = definition.dialog.getValueOf("info", "url");
                if (url === "") {
                    definition.dialog.getContentElement("info", "url").getInputElement().addClass("error");
                    definition.dialog.getContentElement("info", "url").getInputElement().$.placeholder = Translator.translate("LEUIComponents.ckeditor.plugins.link.error.url.required");
                    definition.dialog.getContentElement("info", "url").getInputElement().$.focus();
                    return false;
                }
                else {
                    definition.dialog.getContentElement("info", "url").getInputElement().removeClass("error");
                    definition.dialog.getContentElement("info", "url").getInputElement().$.placholder = "http://";
                }

                var isHTTP = (url.substr(0,4).toLowerCase() === "http");
                var isFTP = (url.substr(0,3).toLowerCase() === "ftp");
                if (!isHTTP && !isFTP) {
                    url = "http://" + url;
                    definition.dialog.setValueOf("info", "url", url);
                }

                // Collect data from fields.
                this.commitContent( data );

                var selection = editor.getSelection();
                var attributes = plugin.getLinkAttributes( editor, data );
                var isNewLink = (!this._.selectedElement);
                var name = definition.dialog.getValueOf("info", "name");
                var text = (name !== "") ? name : definition.dialog.getValueOf("info", "url");
                var range;

                if ( isNewLink ) {

                    range = selection.getRanges()[ 0 ];

                    if (!range) {  //somehow it could happen that the range is not there, need to create it
                        range = editor.createRange();
                    }

                    if (!range.collapsed) {
                        range.deleteContents();
                    }

                    var textNode = new CKEDITOR.dom.text(text, editor.document);

                    range.insertNode(textNode);
                    range.selectNodeContents(textNode);

                    var style = new CKEDITOR.style({ // Apply style.
                        element: 'a',
                        attributes: attributes.set
                    });

                    style.type = CKEDITOR.STYLE_INLINE; // need to override... dunno why.
                    style.applyToRange(range, editor);
                    range.moveToPosition(textNode, CKEDITOR.POSITION_AFTER_END);  //moving selection to end so user can continue typing without overwriting the link's text

                    range = range.clone();
                    style.removeFromRange(range, editor);   //must remove the a style so in FF continuing to type will not be part of the anchor tag
                    editor.getSelection().selectRanges([ range ]);
                }
                else {
                    // We're only editing an existing link, so just overwrite the attributes.
                    var element = this._.selectedElement,
                        href = element.data('cke-saved-href'),
                        textView = element.getHtml();

                    element.setAttributes(attributes.set);
                    element.removeAttributes(attributes.removed);

                    // Update text view when user changes protocol (#4612).
                    if ((href === textView && textView === text) || data.type === 'email' && textView.indexOf('@') !== -1) {
                        // Short mailto link text view (#5736).
                        element.setHtml(data.type === 'email' ?
                            data.email.address : attributes.set[ 'data-cke-saved-href' ]);
                    }
                    else {
                        element.setHtml(text);
                    }

                    delete this._.selectedElement;

                    range = editor.createRange();
                    range.moveToPosition(element, CKEDITOR.POSITION_AFTER_END);     //moving selection to end so user can continue typing without overwriting the link's text
                    editor.getSelection().selectRanges( [ range ] ); //need to create and assign a new range altogether, otherwise ck doesnt allow changing the range for the existing selection
                }
            };
        }
        else if (pluginName === PLUGINS.Smiley) {
            definition.minWidth = 175;
            definition.minHeight = 60;
        }

        definition.onShow = function(ev){
            definition.dialog.getElement().getFirst().addClass("cke_dialog_le");
            definition.dialog.getElement().getFirst().addClass("cke_dialog_"+pluginName);

            //remove cover
            var cover = CKEDITOR.document.find(".cke_dialog_background_cover").getItem(0);
            if (cover) {
                cover.removeAllListeners();
                cover.remove();
            }

            if (onShowOriginal) {
                onShowOriginal.apply(definition.dialog, arguments);
            }

            if (onPluginDialogShow) {
                onPluginDialogShow.apply(definition.dialog, arguments);
            }

            // remove the calculated z-index that CK set inline on the dialog, so we can control it via css file
            definition.dialog.getElement().getFirst().removeStyle("z-index");
        };
    }

    return dialogDefinition;
});